import axios from 'axios'

export default {
    getIcareLocation(){
        return axios.get('/icare-location')
            .then(response => {
                return response.data
            })
    },
    getIcareLocationDataSource(params){
        return axios.get('/icare-location/datasource', {params})
            .then(response => {
                return response.data
            })
    },
    getIcareLocationbyID(id){
        return axios.get('/icare-location/' + id)
            .then(response => {
                return response.data
            })
    },
    createIcareLocation(formdata){
        return axios.post('/icare-location', formdata)
            .then(response => {
                return response.data
            })
    },
    updateIcareLocation(id,formdata){
        return axios.put('/icare-location/' + id, formdata)
            .then(response => {
                return response.data
            })
    },
    deactivateIcareLocation(id){
        return axios.put('/icare-location/' + id + '/deactivate')
            .then(response => {
                return response.data
            })
    },
    reactivateIcareLocation(id){
        return axios.put('/icare-location/' + id + '/reactivate')
            .then(response => {
                return response.data
            })
    },

}
